import '../../App.css';
import './MarketAnalysis.css';
import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom'
import axios from 'axios';
import Appconfig from '../../config/config'


function MarketAnalysis() {
    const navigate = useNavigate();
    const userInfo = JSON.parse(localStorage.getItem('userdata'))


    const [eventsName, setEventsName] = useState([])
    const [angles, setAngles] = useState([]);
    const [cricketEvents, setCricketEvents] = useState([])
    const [tennisEvents, setTennisEvents] = useState([])
    const [soccerEvents, setSoccerEvents] = useState([])
    const [casinoEvents, setCasinoEvents] = useState([])
    // const [isLoading, setIsLoading] = useState(true)



    useEffect(() => {
        setAngles(eventsName.map(() => false));
    }, [eventsName]);


    const getOpenBetEvents = async () => {

        var data = JSON.stringify({
            user_id: userInfo?._id,
        });

        var config = {
            method: "post",
            url: `${Appconfig.apiUrl}betting/getAuraMarketAnalysis`,
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        };

        axios(config)
            .then(function (response) {
                // console.log('response', response);
                if (response.data.result) {
                    setEventsName(response.data.resultData);
                    let allEvents = response.data.resultData;
                    // setIsLoading(false)
                    if (allEvents.length > 0) {
                        const tempCricketEvents = allEvents.filter(event => event.event_type == 4)
                        setCricketEvents(tempCricketEvents)
                        const tempTennisEvents = allEvents.filter(event => event.event_type == 2)
                        setTennisEvents(tempTennisEvents)
                        const tempSoccerEvents = allEvents.filter(event => event.event_type == 1)
                        setSoccerEvents(tempSoccerEvents)
                        const tempCasinoEvents = allEvents.filter(event => event.event_type != 4 && event.event_type != 2 && event.event_type != 1)
                        setCasinoEvents(tempCasinoEvents)
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    useEffect(() => {
        getOpenBetEvents()
    }, [])

    const renderSportSection = (title, events) => {
        if (!events.length) {
            return null;
        }

        return (
            <section className="market-analysis-sport-section">
                <h2 className="market-analysis-sport-title">{title}</h2>

                <div className="market-analysis-event-list">
                    {events.map((event) => (
                        <button
                            key={event.match_id}
                            type="button"
                            className="market-analysis-event-item"
                            onClick={() =>
                                navigate(
                                    `/market-details/${event.event_type}/${event.match_id}`
                                )
                            }
                        >
                            <span className="market-analysis-event-name">
                                {event.event_name}
                            </span>

                            <span className="market-analysis-event-bets">
                                Total Bets: {event.total_bets}
                            </span>
                        </button>
                    ))}
                </div>
            </section>
        );
    };

    return (
        <main className="market-analysis-page">
            <section className="market-analysis-card">
                <header className="market-analysis-header">
                    <div>
                        <h1>Market Analysis</h1>
                        <p>View open betting activity by sport and event.</p>
                    </div>
                </header>

                <div className="market-analysis-content">
                    {renderSportSection('Cricket', cricketEvents)}
                    {renderSportSection('Tennis', tennisEvents)}
                    {renderSportSection('Soccer', soccerEvents)}
                    {renderSportSection('Casino', casinoEvents)}
                </div>
            </section>
        </main>
    );
}


export default MarketAnalysis;
